import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/lib/translations";

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem("wpm-lang");
    if (saved === "en" || saved === "fr") return saved;
    const browser = (navigator.language || "en").slice(0, 2);
    return browser === "fr" ? "fr" : "en";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    window.localStorage.setItem("wpm-lang", lang);
  }, [lang]);

  const setLang = useCallback((l) => setLangState(l === "fr" ? "fr" : "en"), []);

  // Dot-path lookup: t("hero.cta1")
  const t = useCallback(
    (path) => {
      const dict = translations[lang] || translations.en;
      const out = path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), dict);
      if (out === undefined) {
        // Fallback to EN if missing
        const fallback = path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), translations.en);
        return fallback ?? path;
      }
      return out;
    },
    [lang],
  );

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
